<script setup lang="ts">
import type { CabinClass } from '@optionway/models';
import { Check } from 'lucide-vue-next';

const prefix = 'components.search.cabinClassSelector';

const searchCriteriaStore = useSearchCriteriaStore();
const { cabinClassList } = storeToRefs(searchCriteriaStore);

const cabinClass = defineModel<CabinClass>({ default: 'ECONOMY' });

const isOpen = ref(false);
</script>

<template>
  <UiPopover v-model:open="isOpen">
    <UiPopoverTrigger
      class="rounded-md pb-1 pt-2.5 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary-700"
    >
      <UiCustomCollapsibleButtonTrigger
        :expanded="isOpen"
        :label="$t(`${prefix}.${cabinClass}`)"
        label-class="text-text-secondary-600"
        icon-class="text-text-secondary-600"
      />
    </UiPopoverTrigger>
    <UiPopoverContent
      align="start"
      :side-offset="0"
      class="w-56 rounded-md p-1"
    >
      <div
        role="menu"
        class="flex flex-col gap-1"
      >
        <button
          v-for="(aCabinClass, index) in cabinClassList"
          :key="`${aCabinClass}-${index}`"
          role="menuitemradio"
          :aria-checked="aCabinClass === cabinClass"
          class="flex w-full cursor-pointer select-none items-center justify-between gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors hover:bg-accent focus-visible:bg-accent focus-visible:text-inherit focus-visible:ring-2 focus-visible:ring-brand-primary-700"
          :class="aCabinClass === cabinClass ? 'bg-brand-primary-50' : ''"
          @click="
            cabinClass = aCabinClass;
            isOpen = false;
          "
        >
          <span :class="aCabinClass === cabinClass ? 'font-semibold text-text-primary-900' : ''">
            {{ $t(`${prefix}.${aCabinClass}`) }}
          </span>
          <Check
            v-if="aCabinClass === cabinClass"
            aria-hidden="true"
            class="text-brand-primary-700"
          />
        </button>
      </div>
    </UiPopoverContent>
  </UiPopover>
</template>
